module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/watchButton-a890994a1cf637e5c29f42e189261bec.png";